import styled from 'styled-components'

export const TeacherCardsContainer = styled.div`
  display: flex;
  width: 100%;
  overflow: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch; /* For iOS devices */
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  padding: 20px;
  @media (min-width: 768px) {
    padding: 35px;
  }
  @media (min-width: 1024px) {
    padding: 50px;
  }
`

export const TeacherCard = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 30px;
  @media (min-width: 768px) {
    margin-right: 60px;
  }
  @media (min-width: 1024px) {
    margin-right: 90px;
  }
`

export const TeacherImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.5s ease-in-out;
`

export const TeacherImageContainer = styled.div`
  background-image: url(${(props) => props.imgURL});
  background-repeat: no-repeat;
  filter: drop-shadow(0px 4px 33px rgba(0, 0, 0, 0.7));
  overflow: hidden;

  flex: 0 0 180px;
  width: 110px;
  border-radius: 50.5px;
  @media (min-width: 768px) {
    flex: 0 0 350px;
    width: 200px;
    border-radius: 100.5px;
  }
  @media (min-width: 1024px) {
    flex: 0 0 450px;
    width: 250px;
    border-radius: 150.5px;
  }

  &:hover {
    ${TeacherImage} {
      transform: scale(1.05);
    }
  }
`

export const TeacherTitle = styled.div`
  font-family: 'heroregular';
  font-style: normal;
  color: #ffffff;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  margin: 10px 0 0 0;
  @media (min-width: 768px) {
    font-size: 21px;
    line-height: 20px;
  }
  @media (min-width: 1024px) {
    font-size: 28px;
    line-height: 20px;
  }
`
